import React, { useState } from "react";
import { GetAdminCoursesSlim } from "../../actions/adminQueries";
import { useQueryClient } from "@tanstack/react-query";
import { Table, Input, Button, Row, Col } from "reactstrap";
import CreateCourse from "../../components/Modal/CreateCourse";
import { PacmanLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CourseAdminNav from "../../components/Navigation/CourseAdminNav";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import { API_BASE_URL } from "../../constants/api.constants";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";
import { useIntl } from "react-intl";
import { PiCheckCircle, PiWarningCircle } from "react-icons/pi";
import { useNavigate } from "react-router-dom";

function CoursesList() {
  const intl = useIntl();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const courses = GetAdminCoursesSlim();

  const [filterSearch, setFilterSearch] = useState("");
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [updatingCourse, setUpdatingCourse] = useState([]);

  const updateCourses = () => {
    courses.refetch();
  };

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const selectCourse = (course, programLicenses) => {
    course.programLicenses = programLicenses;
    setSelectedCourse(course);
    toggleModal();
  };

  const deleteCourse = (courseId) => {
    axios
      .delete("/Course/" + courseId)
      .then((response) => {})
      .catch((err) => {
        toast.warn(err.response.data);
      });

    queryClient.setQueryData(["FetchAdminCoursesSlim"], (old) =>
      (old || []).filter((course) => course.id !== courseId)
    );
  };

  const setHideStatus = (courseId, hideForStudents, hideForTeachers) => {
    axios
      .post(`${API_BASE_URL}/Course/SetHideStatus/`, {
        id: courseId,
        hideForStudents: hideForStudents,
        hideForTeachers: hideForTeachers,
      })
      .then(() => {
        toast.success("Hide status ändrad", TOAST_CONFIG);
        updateCourses();
      })
      .catch((err) => {
        toast.warn(
          err && err.response && err.response.data
            ? err.response.data
            : "Det gick inte att sätta hide status",
          TOAST_CONFIG
        );
      });
  };

  const createNew = () => {
    setSelectedCourse(null);
    toggleModal();
  };

  const handleFilterSearch = (event) => {
    setFilterSearch(event.target.value);
  };

  const handleToggleCourseAsLoading = (courseId) => {
    if (updatingCourse.includes(courseId)) {
      setUpdatingCourse(updatingCourse.filter((course) => course !== courseId));
      updateCourses();
    } else {
      setUpdatingCourse([...updatingCourse, courseId]);
    }
  };

  if (courses.isPending === true) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  let coursesFilteredByName = null;
  let coursesFilteredByDescription = null;

  var filteredCourses = courses.data || [];
  if (filterSearch.length > 0) {
    coursesFilteredByName = filteredCourses.filter((it) =>
      (it.course.name ?? "")
        .toLowerCase()
        .includes(filterSearch.toLowerCase())
    );
    coursesFilteredByDescription = filteredCourses.filter((it) =>
      (it.course.description ?? "")
        .toLowerCase()
        .includes(filterSearch.toLowerCase())
    );
    let tempAllFilteredCourses = [...coursesFilteredByName];
    coursesFilteredByDescription.forEach((fd) => {
      if (
        !tempAllFilteredCourses.some((to) => to.course.id === fd.course.id)
      ) {
        tempAllFilteredCourses.push(fd);
      }
    });
    filteredCourses = tempAllFilteredCourses;
  }

  let availableProgramLicenses = [];

  (courses.data ?? []).forEach((item) => {
    if (item.programs?.length > 0) {
      item.programs.forEach((prog) => {
        if (
          availableProgramLicenses.filter(
            (x) => x.licenseName === prog.licenseName
          ).length === 0
        ) {
          availableProgramLicenses.push(prog);
        }
      });
    }
  });

  var mappedCourses = filteredCourses.map((course, id) => {
    var programs = [];
    if (course.programs?.length > 0) {
      course.programs.forEach((license) => {
        if (programs.indexOf(license.licenseName) === -1)
          programs.push(license.licenseName);
      });
    }
    return (
      <tr key={id}>
        <td>
          <div
            className={
              course.course.imgUrl !== undefined
                ? "avatar float-start"
                : "d-none"
            }
            style={{ marginRight: "10px" }}
          >
            <img src={course.course.imgUrl} className="img-avatar" alt="" />
          </div>
        </td>

        <td>
          <Button
            size="sm"
            color="link"
            title={"Klicka för att redigera kurs:" + course.course.name}
            onClick={() => selectCourse(course.course, programs)}
            className="text-start w-100"
          >
            {course.course.name}
          </Button>
          {updatingCourse.includes(course.course.id) ? (
            <p>
              <PacmanLoader color={"#20a8d8"} loading={true} size={10} />
            </p>
          ) : (
            ""
          )}
        </td>
        <td>
          {course.course?.courseModules.filter((cm) => cm.sortOrder === 0)
            .length >= 2 && (
            <PiWarningCircle
              className="warning-icon"
              title={intl.formatMessage({
                id: "ModulesNotSorted",
              })}
            />
          )}
        </td>
        <td>
          {course.course.teacherGuideFileUrl != null && (
            <PiCheckCircle className="text-success fs-5" />
          )}
        </td>
        <td className="text-end">{course.course.id}</td>
        <td>{course.course.code}</td>
        <td>{course.course.description}</td>
        <td className="text-end">
          <Button
            size="sm"
            outline
            color="primary"
            title={
              "Klicka för att redigera moudler till kurs:" +
              course.course.name
            }
            onClick={() =>
              navigate("/superuser/courses/coursemodules", {
                state: {
                  courseId: course.course.id,
                  courseName: course.course.name,
                },
              })
            }
          >
            {course.course.courseModules.length}
          </Button>
        </td>
        <td title={programs.join(", ")} className="text-end">
          <span>{programs.length}</span>
        </td>
        <td align="center">
          <Button
            size="sm"
            outline
            color="blue"
            onClick={() =>
              setHideStatus(
                course.course.id,
                !course.course.hideCourseForStudents,
                course.course.hideCourseForTeachers
              )
            }
          >
            <FontAwesomeIcon
              icon="check"
              opacity={course.course.hideCourseForStudents ? 1 : 0}
            />
          </Button>
        </td>
        <td align="center">
          <Button
            size="sm"
            outline
            color="blue"
            onClick={() =>
              setHideStatus(
                course.course.id,
                course.course.hideCourseForStudents,
                !course.course.hideCourseForTeachers
              )
            }
          >
            <FontAwesomeIcon
              icon="check"
              opacity={course.course.hideCourseForTeachers ? 1 : 0}
            />
          </Button>
        </td>
        <td>
          <Button
            size="sm"
            outline
            color="danger"
            title={"Radera kurs:" + course.course.name}
            onClick={() => deleteCourse(course.course.id)}
          >
            <FontAwesomeIcon icon="trash" />
          </Button>
        </td>
      </tr>
    );
  });

  return (
    <div>
      <CourseAdminNav location="courses" />

      <div className="container-fluid admin-container">
        <Row className="mb-2">
          <Col className="col-3">
            <Input
              className="search-input"
              placeholder="Sök kurs"
              onChange={handleFilterSearch}
            />
          </Col>
          <Col lg={9}>
            <Button
              size="md"
              outline
              color="primary"
              className="float-end"
              style={{ marginTop: "-10px" }}
              onClick={() => {
                createNew();
              }}
            >
              <FontAwesomeIcon icon="plus" />
              &nbsp;
              <span className="">Ny kurs</span>
            </Button>
          </Col>
        </Row>
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <Table hover striped className="school-table">
            <thead className="sticky-header">
              <tr>
                <th />
                <th>Namn</th>
                <th></th>
                <th>
                  <FormattedMessage id="Guide" />
                </th>
                <th>
                  <FormattedMessage id="CourseId" />
                </th>
                <th>Kod</th>
                <th>Beskrivning</th>
                <th>Moduler</th>
                <th>Programlicenser</th>
                <th>Dold elever</th>
                <th>Dold lärare</th>
                <th>Radera</th>
              </tr>
            </thead>
            <tbody>{mappedCourses}</tbody>
          </Table>
        </div>
      </div>

      <CreateCourse
        isOpen={modalIsOpen}
        toggle={toggleModal}
        toggleExpand={toggleExpand}
        isExpanded={isExpanded}
        updateCourse={selectedCourse}
        refreshList={updateCourses}
        availableProgramLicenses={availableProgramLicenses}
        handleToggleCourseAsLoading={handleToggleCourseAsLoading}
      />
    </div>
  );
}

export default CoursesList;
